import React from 'react';
import { Navigate } from 'react-router';
import { Loader } from '@thinknet-gmbh/platform-common-ui';
import { MemberTypesEnum, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';

import { usePermissionContext } from '../../../contexts';
import { useGetOwnData } from 'src/hooks/employees/get-own-data.hook';

import { ROUTES } from '../../app/app-routes.constants';


const EmployeeRouteGuard = ({ children }: { children?: React.ReactNode }) => {
  const { permissions } = usePermissionContext();

  const { employee, loading } = useGetOwnData();

  if (loading) {
    return <Loader />;
  }

  if (String(employee?.type) === String(MemberTypesEnum.OWNER)) {
    return <>{children}</>;
  }

  const checkIfHadPermission = (permission?: string) =>
    permissions.find(item => item?.permission === permission);

  return checkIfHadPermission(PLATFORM_PERMISSIONS.memberManagement) ? (
    <>{children}</>
  ) : (
    <Navigate to={{ pathname: ROUTES.dashboard }} />
  );
};

export default EmployeeRouteGuard;
